import { XClose } from '@untitled-ui/icons-react';
import React from 'react';
import { twMerge } from 'tailwind-merge';

export enum TopBarVariant {
  Default = 'default',
  PaymentFailed = 'payment-failed',
  PaymentCancelled = 'payment-cancelled',
  MaintenanceInfo = 'maintenance-info',
  MaintenanceWarning = 'maintenance-warning',
  MaintenanceError = 'maintenance-error',
}

export interface TopBarProps {
  variant?: TopBarVariant;
  icon?: React.ReactNode;
  alertMessage: string;
  linkMessage: string;
  shouldDisplayLink?: boolean;
  canCloseNotification?: boolean;
  onCloseNotification?: () => void;
  onClick?: () => void;
}

export function TopBar(props: TopBarProps) {
  const {
    variant = 'default',
    onClick,
    icon,
    alertMessage,
    linkMessage,
    shouldDisplayLink = true,
    canCloseNotification = false,
    onCloseNotification,
  } = props;

  return (
    <div
      className={twMerge(
        'relative flex h-[44px] w-full items-center justify-center bg-indigo-600 px-6 text-white',
        variant == TopBarVariant.PaymentFailed ? 'bg-red-600' : '',
        variant == TopBarVariant.PaymentCancelled
          ? 'bg-gradient-to-r from-branding-accent-600 to-purple-700'
          : '',
        variant == TopBarVariant.MaintenanceInfo ? 'bg-branding-accent' : '',
        variant == TopBarVariant.MaintenanceWarning ? 'bg-yellow-600' : '',
        variant == TopBarVariant.MaintenanceError ? 'bg-red-600' : ''
      )}
    >
      <div className="flex items-center gap-3">
        {icon != null ? icon : null}
        <span className="text-sm font-medium" dangerouslySetInnerHTML={{ __html: alertMessage }} />
      </div>
      {shouldDisplayLink ? (
        <p className="font-body-2-sb ml-4 cursor-pointer text-white underline" onClick={onClick}>
          {linkMessage}
        </p>
      ) : null}
      {canCloseNotification ? (
        <button className="absolute right-4 top-1/2 -translate-y-1/2" onClick={onCloseNotification}>
          <XClose width={16} height={16} />
        </button>
      ) : null}
    </div>
  );
}
